import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import Landing from './pages/Landing';
import WhyChooseUs from './pages/WhyChooseUs';
import Contact from './pages/Contact';
import Locations from './pages/Locations';
import Services from './pages/Services';
import Dealers from './pages/Dealers';
import BlogIndex from './pages/BlogIndex';
import BlogPost from './pages/BlogPost';

function App() {
  return (
    <div className="App min-h-screen md:bg-slate-200 lg:bg-transparent">
      <BrowserRouter>
        <div className="relative mx-auto w-full bg-white md:max-w-[640px] lg:max-w-none md:min-h-screen md:shadow-[0_0_80px_rgba(15,23,42,0.15)]">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/services" element={<Services />} />
            <Route path="/dealers" element={<Dealers />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/why-choose-us" element={<WhyChooseUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
